import { Wrapper } from './ComparePagePassportStyle';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import { PassportForm, PassportProvider } from '../../../passport/Passport';
import { Color } from '../../../components/ThemeProvider/ThemeStyle';
import React, { useEffect, useState } from 'react';
import { DocumentApi } from '../../../_helpers/service';
import { PhotoWrapper } from '../../ContingentPassportPage/ContingentPassportStyle';
import { useTranslation } from 'react-i18next';

export default function ContingentPassportItem({ data, meta, info, url }) {
  const [urlImg, setUrlImg] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (url) {
      DocumentApi.view(url, 1).then(response => {
        setUrlImg(URL.createObjectURL(response.data));
      });
    }
  }, []);

  return (
    <Wrapper className="px1 pb2 py2">
      <ErrorBoundary>
        <PassportProvider
          withoutScroll={false}
          stickyTop={Color.headerHeight}
          info={info}
          data={
            JSON.stringify(data) === '{}'
              ? { metadataKey: 'form_contingent_do_child' }
              : data
          }
          meta={meta}
          config={{
            documentsProps: {
              mimeType: 'image/jpeg,image/png,application/pdf',
              maxSize: 10000000,
              'form_contingent_do_child.Foto': {
                mimeType: 'image/jpeg,image/png,image/jpg,image/jfif',
                maxSize: 10000000
              }
            }
          }}
        >
          {/*<PassportExpander />*/}

          <div className="passport-container">
            <div className="passport-left">
              <div className="mb2">
                {urlImg ? (
                  <>
                    <div style={{ width: '220px', height: '240px' }}>
                      <img
                        src={urlImg}
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '6px'
                        }}
                        alt=""
                      />
                    </div>
                  </>
                ) : (
                  <PhotoWrapper>
                    <p> {t('contingentPassport_noPhoto')} </p>
                  </PhotoWrapper>
                )}
              </div>
              {/*<PassportNavigation />*/}
            </div>
            <div className="passport-form ml2 flex-auto">
              <PassportForm />
            </div>
          </div>
        </PassportProvider>
      </ErrorBoundary>
    </Wrapper>
  );
}
